<template>
  <div class="login-page">
    <div class="signup-confirmation-block">
      <span class="icon icon-close" />
      <h2>Verification Failed!</h2>
      <div>Something went wrong!</div>
      <div>
        Please contact support at
        <a class="cursor-pointer">minions@lifetraq.com</a>
      </div>
    </div>
  </div>
</template>

<script>
import { changeTopNavTitle } from "PublicHelpers/changeTopNavTitle";

export default {
  name: "VerificationFailed",
  mounted() {
    changeTopNavTitle(this, "Verification Failed", "Verification Failed");
  },
};
</script>

<style scoped></style>
